import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import SecureBaseStore from "./SecureBaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SavingStates from "../constants/states/SavingStates";
import {FormFieldWithValidityState} from "./FormFieldWithValidityState";

class PhoneNumberVerificationViewState {
    constructor(
        codeCheckState,
        smsSendState,
        validationCode
    ) {
        this.codeCheckState = codeCheckState;
        this.smsSendState = smsSendState;
        this.validationCode = validationCode;
    }

    equals(other) {
        return this.codeCheckState === other.codeCheckState &&
            this.smsSendState === other.smsSendState &&
            this.validationCode.equals(other.validationCode);
    }
}

class ImmutablePhoneNumberVerificationViewStateBuilder {

    constructor() {
        this.codeCheckState = SavingStates.NOT_STARTED;
        this.smsSendState = SavingStates.NOT_STARTED;
        this.validationCode = FormFieldWithValidityState.initialDefaults("");
    }

    static fromState(state) {
        return new ImmutablePhoneNumberVerificationViewStateBuilder()
            .setCodeCheckState(state.codeCheckState)
            .setSMSSendState(state.smsSendState)
            .setValidationCode(state.validationCode.currentValue, state.validationCode.isValid, state.validationCode.isTouched)
    }

    setCodeCheckState(newState) {
        this.codeCheckState = newState;
        return this;
    }

    setSMSSendState(newState) {
        this.smsSendState = newState;
        return this;
    }

    setValidationCode(validationCode, isValid, isTouched) {
        this.validationCode = new FormFieldWithValidityState(validationCode, isValid, isTouched);
        return this;
    }

    build() {
        return Object.freeze(
            new PhoneNumberVerificationViewState(
                this.codeCheckState,
                this.smsSendState,
                this.validationCode));
    }
}


class PhoneNumberVerificationViewStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.PHONE_NUMBER_VERIFICATION_VIEW_STORE_UPDATED, ImmutablePhoneNumberVerificationViewStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.PHONE_NUMBER_VERIFICATION_CODE_CHANGED, this.handleValidationCodeChanged);
        this.subscribeToEvent(UIInteractionEvents.PHONE_NUMBER_VERIFICATION_CHECK_SUBMITTED, this.handleCheckStarted);
        this.subscribeToEvent(UIInteractionEvents.PHONE_NUMBER_VERIFICATION_SMS_REQUESTED, this.handlePhoneNumberSendStarted);
        this.subscribeToEvent(ActionResultEvents.PHONE_NUMBER_VERIFICATION_SMS_SENT, this.handlePhoneNumberSent);
        this.subscribeToEvent(ActionResultEvents.PHONE_NUMBER_VERIFICATION_INVALID_CODE, this.handleInvalidCode);
        this.subscribeToEvent(ActionResultEvents.PHONE_NUMBER_VERIFICATION_SUCCESS, this.resetStore);

    }

    handleCheckStarted = (topic, data) => {
        return ImmutablePhoneNumberVerificationViewStateBuilder.fromState(this.state)
            .setCodeCheckState(SavingStates.SAVING)
            .build();
    };

    handlePhoneNumberSendStarted = (topic, data) => {
        return ImmutablePhoneNumberVerificationViewStateBuilder.fromState(this.state)
            .setSMSSendState(SavingStates.SAVING)
            .build();
    };

    handlePhoneNumberSent = (topic, data) => {
        return ImmutablePhoneNumberVerificationViewStateBuilder.fromState(this.state)
            .setSMSSendState(SavingStates.NOT_STARTED)
            .build();
    };

    handleInvalidCode = (topic, data) => {
        return ImmutablePhoneNumberVerificationViewStateBuilder.fromState(this.state)
            .setCodeCheckState(SavingStates.FAILED_TO_SAVE)
            .setValidationCode(this.state.validationCode.currentValue, false, true)
            .build();
    };

    handleValidationCodeChanged = (topic, data) => {
        return ImmutablePhoneNumberVerificationViewStateBuilder.fromState(this.state)
            .setValidationCode(data.validationCode, data.isValid, true)
            .build();
    };


}

export default new PhoneNumberVerificationViewStore();